import { Component } from 'react';
import { bool, node, func } from 'prop-types';

import { withMeetingContext, MeetingContextDevicePermissionsProps } from 'Scenes/_root/meetingContext';

class DevicePermissions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.devicePermissions.getDevicePermissions(),
    };
  }

  componentDidMount() {
    this.deregisterMeetingCallbacks = this.props.registerMeetingCallbacks('devicePermissionsWrapper', {
      onDevicePermissionChange: this.onDevicePermissionChange,
    });
    if (this.props.enabled) {
      this.promptForPermissions();
    }
  }

  componentWillUnmount() {
    this.deregisterMeetingCallbacks();
  }

  onDevicePermissionChange = (permissionName, permissionState) => {
    this.setState({
      [permissionName]: permissionState,
    }, this.openModalIfPermissionNotGranted);
  }

  promptForPermissions = async () => {
    const {
      devicePermissions,
    } = this.props;
    await devicePermissions.check('camera');
    await devicePermissions.check('microphone');
  }

  openModalIfPermissionNotGranted = () => {
    const {
      enabled,
      openDevicePermissionsModal,
    } = this.props;
    const {
      camera,
      microphone,
    } = this.state;

    if (enabled) {
      if (camera === 'denied' || microphone === 'denied') {
        openDevicePermissionsModal();
      }
    }
  }

  render() {
    return this.props.children;
  }
}

DevicePermissions.propTypes = {
  children: node.isRequired,
  enabled: bool.isRequired,
  openDevicePermissionsModal: func.isRequired,
  devicePermissions: MeetingContextDevicePermissionsProps,
  registerMeetingCallbacks: func.isRequired,
};

export default withMeetingContext(['devicePermissions', 'registerMeetingCallbacks'])(DevicePermissions);
